<template>
    <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
            <h3 class="text-themecolor">General Partner
                <span class="card-subtitle" v-if="user.profile">{{user.profile.first_name+' '+user.profile.last_name}} ({{user.email}})</span>
                <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/users/general-partners')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">General Partners</span></button>
            </h3>
        </div>
        <div class="container-fluid p-0 pta-gp-weightings" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-12 col-sm-8">
                    <div class="card">
                        <div class="card-body p-4">
                            <div class="row">
                                <user-sidebar menu="login-log" :id="id"></user-sidebar>
                                <div class="col-9 col-sm-9">
                                     <h4 class="card-title">Login Log</h4>

                                  <div class="table-responsive" v-if="login_logs.length">
                                    <table class="table table-hover">
                                      <thead>
                                      <tr>
                                        <th scope="col">Date</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      <tr v-for="login_log in login_logs">
                                        <td v-if="login_log.created_at">{{ login_log.created_at | momentTime }}</td><td v-else>-</td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </div><div v-else>No entries found.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <user-summary :user="user"></user-summary>
            </div>
        </div>
    </div>
</template>
<script>
    import userSidebar from './general-partner-sidebar'
    import userSummary from './summary'
    import switches from 'vue-switches'

    /*
• Weights assigned to different parameters (optional parameters, default value: 1)
• weights.hqcountry: HQ Country [value between 1 and 10]
• weights.hqcontinent: HQ Continent [value between 1 and 10]
• weights.geo: Preferred Geography [value between 1 and 10]
• weights.cont: Continent [value between 1 and 10]
• weights.struc: Investment Structure [value between 1 and 10]
• weights.fundtype: Preferred Fund Type [value between 1 and 10]
• weights.fundtypecat: Fund Type Category [value between 1 and 10]
• weights.lptype: LP Type [value between 1 and 10]
• weights.esg: ESG Status [value between 1 and 10]
• weights.ftf: First time fund [value between 1 and 10]
     */

    export default {
        components : { switches,userSidebar,userSummary },
        data() {
            return {
                id:this.$route.params.id,
                login_logs: [],
                is_loading: true,
                user: '',
                investors: ''
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/account/dashboard');
            }
            this.fetchUserData();
        },
        methods: {
          fetchUserData(){
            axios.get('/api/user/'+this.id)
                .then(response => response.data)
                .then(response => {
                  this.user = response.user;
                  this.login_logs = response.user.user_last_logins;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error);
                  this.$router.push('/user');
                })
          },
        },
      filters: {
        moment(date) {
          return helper.formatDate(date);
        },
        momentTime(date) {
          return helper.formatDateTime(date);
        }
      }
    }
</script>
